// extracted by mini-css-extract-plugin
module.exports = {"playButton":"VideoThumbnail_playButton__3q7LY"};